/**
 * Usage
 * Closest Parent should be a div with className 'relative'
 */

function InlineLoader({ children }) {
    return (
        <div className="absolute inset-0 bg-orange-200 z-20 text-center">
            <div className="flex w-full h-full items-center justify-center">
                {' '}
                {children}{' '}
            </div>
        </div>
    )
}

export default InlineLoader
